import { sector } from "@app/shared/models/sector";
import { Client } from "@app/shared/models/client";

export class AnswerSet {
  answerSetName: string;
  body?: any[];
  client?: Client;
  clientId: string;
  clientSiteId: string;
  created?: string;
  modified?: string;
  createdBy?: string;
  modifiedBy?: string;
  id?: string;
  questionnaireId: string;
  questionnaireName: string;
  sectors: sector[] = new Array<sector>();

  constructor(
    id: string,
    answerSetName: string,
    clientId: string,
    clientSiteId: string,
    questionnaireId: string,
    sectors: sector[]
  ) {
    this.id = id;
    this.answerSetName = answerSetName;
    this.clientId = clientId;
    this.clientSiteId = clientSiteId;
    this.questionnaireId = questionnaireId;
    this.sectors = sectors;
  }
}

export interface IAnswerSet {
  metadata: {
    id: number;
    title: string;
    questionnaireId: number;
    clientId: string;
    createdDate: string;
    createdBy: string;
    modifiedDate: string;
    modifiedBy: string;
    isCompleted: boolean;
    sector: sector;
    siteId: string;
  };
  answerSetJson: string;
}
